// 环境配置
const env = process.env.NODE_ENV || 'development';

// 只在开发环境中使用localStorage存储的环境配置
const currentEnv = env === 'development' && typeof window !== 'undefined' 
  ? localStorage.getItem('current_env') || env 
  : env;

// API 配置
const API_CONFIG = {
  // 开发环境默认使用测试服
  development: {
    baseURL: 'https://puhuitong.cc/api/',
    title: '街道业务管理系统(测试环境)'
  },
  // 生产环境使用正式服
  production: {
    baseURL: 'https://puhuitong.cc/api/',
    title: '街道业务管理系统'
  }
};

// 导出当前环境的配置
export const config = API_CONFIG[currentEnv] || API_CONFIG.development;

// 导出所有配置，方便切换
export const allConfigs = API_CONFIG;

// 切换环境的工具函数（仅在开发环境可用）
export function switchEnvironment(env) {
  // 只在开发环境允许切换
  if (process.env.NODE_ENV === 'development' && API_CONFIG[env]) {
    localStorage.setItem('current_env', env);
    window.location.reload();
  }
}

// 获取当前环境
export function getCurrentEnvironment() {
  // 只在开发环境返回localStorage中的环境，否则返回当前构建环境
  return process.env.NODE_ENV === 'development' && typeof window !== 'undefined'
    ? localStorage.getItem('current_env') || env
    : env;
}